import { data } from '../../svg/Error/data';
import { makeIcon } from '../makeIcon';

export const Error = makeIcon(data, 'error', 'Error');

export default Error;
